export default __webpack_public_path__ + "static/media/productHealthCheckPackage1_Cn.d0ccff8a.webp";